// 节点表格配置
export const nodeOptions = {
    border: true,
    size: 'small',
    height: '100%',
    tooltipConfig: { zIndex: 9999 },
    rowConfig: {
        isHover: true,
        isCurrent: true
    },
    columns: [
        { field: 'node', title: '操作节点', width: 100, align: 'center' }
    ],
    data: []
};

// 订单表格配置
export const orderOptions = {
    border: true,
    size: 'small',
    height: '100%',
    tooltipConfig: { zIndex: 9999 },
    rowConfig: {
        isHover: true,
        isCurrent: true
    },
    treeConfig: {
        rowField: 'id',
        children: 'childList'
    },
    virtualYConfig: {
        enabled: true,
        gt: 0
    },
    columns: [
        {
            title: '单号',
            field: 'orderNo',
            treeNode: true,
            slots: { header: 'header_filter_orderNo' }
        }
    ],
    data: []
};

// 日志表格配置
export const logOptions = {
    border: true,
    size: 'small',
    height: '100%',
    stripe: true,
    columnConfig: { resizable: true },
    rowConfig: { isHover: true },
    tooltipConfig: { zIndex: 9999 },
    showOverflow: true,
    virtualYConfig: {
        enabled: true,
        gt: 0
    },
    columns: [
        { field: 'updateTime', title: '操作时间', width: 140, showOverflow: true, sortable: true, align: 'center' },
        { field: 'operatorCode', title: '操作人账号', width: 100, showOverflow: true, align: 'center' },
        { field: 'operatorName', title: '操作人姓名', width: 90, showOverflow: true, align: 'center' },
        { field: 'operationName', title: '操作类型', width: 110, showOverflow: true, align: 'center' },
        { field: 'operationResult', title: '操作结果', width: 80, showOverflow: true, align: 'center' },
        { field: 'fenceDistanceKm', title: '围栏距离', width: 80, showOverflow: true, align: 'center' },
        { field: 'picList', title: '图片', width: 80, slots: { default: 'imgUrl_default' }, align: 'center' },
        { field: 'location', title: '经纬度', width: 80, showOverflow: true, align: 'center' },
        { field: 'remark', title: '备注', showOverflow: true, align: 'center' }
    ],
    data: []
};
